import { Box, ButtonBase, TableCell, TableRow } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  color: theme.palette.secondary.main,
  backgroundColor: '#F1F5FA',
  fontSize: '16px',
}));

export const StyledButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: '600',
  textDecoration: 'underline',
  fontSize: '14px',
  padding: '4px',
}));

export const StyledCell = styled(TableCell)(({ theme }) => ({
  color: '#707070',
  [theme.breakpoints.up('xl')]: {
    padding: '24px 12px',
  },
}));

export const Row = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.grey, 0.2),
  },
}));

export const SortableTableCellHeader = styled(TableCellHeader)(() => ({
  cursor: 'pointer',
  fontSize: '16px',
}));

export const SortableBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 0,
}));
